<template>
  <LayoutSite>
    <Formulario titulo="Pendências">
      <v-card-title>
        <export-excel :data="items" :fields="campos_excel" worksheet="Prazos" name="Prazos.xls">
          <v-btn icon color="green">
            <v-icon>mdi-file-excel-box-outline</v-icon>
          </v-btn>
        </export-excel>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-btn color="teal" dark class="mb-2" @click="getfiltros()">FILTROS</v-btn>
      </v-card-title>
      <v-card class="mx-auto" flat v-if="filtros">
        <v-card-text>
          <v-row class="row-form">
            <v-col cols="3">
              <v-autocomplete
                label="Empresa"
                v-model="filtro.empresa_id"
                :items="empresas"
                item-text="nome"
                item-value="id"
                autofocus
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                label="Escritório"
                v-model="filtro.escritorio_id"
                :items="escritorios"
                item-text="nome"
                item-value="id"
                clearable
                @blur="carregar('advogado')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                label="Advogado"
                v-model="filtro.advogado_id"
                :items="advogados"
                item-text="nome"
                item-value="id"
                clearable
                :disabled="advogadoDisabled"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-text-field label="Nº Processo" v-model="filtro.numero"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="row-form">
            <v-col cols="3">
              <v-text-field label="Reclamante" v-model="filtro.reclamante"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field label="Reclamada" v-model="filtro.reclamada"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                label="Tipo Ato"
                v-model="filtro.tipoato"
                :items="tiposato"
                item-text="nome"
                item-value="id"
                clearable
                @blur="carregar('tipo')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                label="Tipo de Prazo"
                v-model="filtro.tipo_id"
                :items="tipos"
                item-text="nome"
                item-value="id"
                clearable
                :disabled="tipoDisabled"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="row-form">
            <v-col cols="3">
              <v-text-field label="ID Prazo" v-model="filtro.calculo_id"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field label="Solicitação" v-model="filtro.solicitacao"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                label="Status"
                v-model="filtro.status_id"
                :items="status"
                item-text="nome"
                item-value="id"
                clearable
                multiple
                small-chips
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                label="Responsável"
                v-model="filtro.responsavel_id"
                :items="usuarios"
                item-text="name"
                item-value="id"
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="row-form">
            <v-col cols="3">
              <v-menu
                ref="dtsolic"
                v-model="dtsolic"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="filtro.datasolicitacao"
                    label="Data Solicitação Início"
                    persistent-hint
                    @blur="datasolic = parseDate(filtro.datasolicitacao)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="datasolic" no-title @input="dtsolic = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="3">
              <v-menu
                ref="dtsolicFim"
                v-model="dtsolicFim"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="filtro.datasolicitacaoFim"
                    label="Data Solicitação Fim"
                    persistent-hint
                    @blur="datasolicFim = parseDate(filtro.datasolicitacaoFim)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="datasolicFim" no-title @input="dtsolicFim = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="3">
              <v-menu
                ref="dtfatal"
                v-model="dtfatal"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="filtro.datafatal"
                    label="Data Fatal Início"
                    persistent-hint
                    @blur="datafatal = parseDate(filtro.datafatal)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="datafatal" no-title @input="dtfatal = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="3">
              <v-menu
                ref="dtfatalFim"
                v-model="dtfatalFim"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="filtro.datafatalFim"
                    label="Data Fatal Fim"
                    persistent-hint
                    @blur="datafatalFim = parseDate(filtro.datafatalFim)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="datafatalFim" no-title @input="dtfatalFim = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="row-form">
            <v-col cols="3">
              <v-menu
                ref="dtconcl"
                v-model="dtconcl"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="filtro.dataconclusao"
                    label="Data Conclusão Início"
                    persistent-hint
                    @blur="dataconcl = parseDate(filtro.dataconclusao)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dataconcl" no-title @input="dtconcl = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="3">
              <v-menu
                ref="dtconclFim"
                v-model="dtconclFim"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="filtro.dataconclusaoFim"
                    label="Data Conclusão Fim"
                    persistent-hint
                    @blur="dataconclFim = parseDate(filtro.dataconclusaoFim)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dataconclFim" no-title @input="dtconclFim = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                label="Em Tratamento"
                v-model="filtro.emtratamento"
                :items="simounao"
                item-text="nome"
                item-value="id"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                label="Possui Pendências"
                v-model="filtro.pendencias"
                :items="simounao"
                item-text="nome"
                item-value="id"
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="row-form">
            <v-spacer></v-spacer>
            <v-btn color="warning" dark class="mb-2" @click="limpar()">Limpar</v-btn>
            <v-btn color="teal" dark class="mb-2" @click="pesquisar()">Pesquisar</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Pesquisar"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="items" :search="search">
        <template v-slot:item="props">
          <tr @dblclick="openform('editar',props.item.id)">
            <td class="text-left">{{props.item.id}}</td>
            <td class="text-left">{{props.item.dtfatal }}</td>
            <td class="text-left">{{props.item.dtsolic }}</td>
            <td class="text-left">{{props.item.numero }}</td>
            <td class="text-left">{{props.item.reclamante }}</td>
            <td class="text-left">{{props.item.reclamada }}</td>
            <td class="text-left">{{props.item.tipo }}</td>
            <td class="text-left">{{props.item.solicitante }}</td>
          </tr>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="mdi-alert-outline"
        >Sua Pesquisa por "{{ search }}" não encontrou registros.</v-alert>
      </v-data-table>
    </Formulario>
  </LayoutSite>
</template>

<script>
import LayoutSite from "@/components/layout/LayoutSite";
import Formulario from "@/components/Form";

export default {
  components: {
    LayoutSite,
    Formulario
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "ID", value: "id" },
        { text: "Data Fatal", value: "datafatal" },
        { text: "Data Pend.", value: "datapend" },
        { text: "Nº Processo", value: "numero" },
        { text: "Reclamante", value: "reclamante" },
        { text: "Reclamada", value: "reclamada" },
        { text: "Adv.", value: "advogado" },
        { text: "Tipo", value: "tipo" },
        { text: "Resp.", value: "responsavel" },
        { text: "Status", value: "status" },
        { text: "Tratamento", value: "emtratamento" },
        { text: "Pendências", value: "possui_pendencias" }
      ],
      items: [],
      campos_excel: {
        ID: "id",
        "Data Fatal": "datafatal",
        "Nº Processo": "numero",
        Reclamante: "reclamante",
        Reclamada: "reclamada",
        Advogado: "advogado",
        "Tipo de Prazo": "tipo",
        Responsável: "responsavel",
        Status: "status",
        "Em Tratamento": "emtratamento",
        "Possui Pendências": "possui_pendencias"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      filtro: {
        calculo_id: "",
        empresa_id: 0,
        escritorio_id: 0,
        advogado_id: 0,
        numero: "",
        estado_id: 0,
        cidade_id: 0,
        reclamante: "",
        reclamada: "",
        tipoato: 0,
        tipo_id: "",
        solicitacao: "",
        datasolicitacao: "",
        datasolicitacaoFim: "",
        datafatal: "",
        datafatalFim: "",
        dataconclusao: "",
        dataconclusaoFim: "",
        pendencias: 0,
        emtratamento: 0,
        status_id: null,
        responsavel_id: 0,
        id: 0
      },
      filtros: false,
      empresas: [],
      escritorios: [],
      advogados: [],
      estados: [],
      cidades: [],
      tipos: [],
      usuarios: [],
      status: [],
      erros: [],
      tiposato: [
        { id: 1, nome: "Execução" },
        { id: 2, nome: "Provisão" }
      ],
      simounao: [
        { id: 1, nome: "Sim" },
        { id: 2, nome: "Não" }
      ],
      dtsolic: false,
      dtsolicFim: false,
      dtconcl: false,
      dtconclFim: false,
      dtfatal: false,
      dtfatalFim: false,
      datasolic: new Date().toISOString().substr(0, 10),
      datasolicFim: new Date().toISOString().substr(0, 10),
      datafatal: new Date().toISOString().substr(0, 10),
      datafatalFim: new Date().toISOString().substr(0, 10),
      dataconcl: new Date().toISOString().substr(0, 10),
      dataconclFim: new Date().toISOString().substr(0, 10),
      permissoes: {
        prazo: false,
        prazo_incluir: false
      }
    };
  },
  created: function() {
    let permAux = this.$store.getters.getPermissoes;

    if (permAux.ativo) {
      this.permissoes = permAux;
      if (!this.permissoes.prazo) this.$router.push("/");
    } else this.$router.push("/");

    this.getData();
  },
  computed: {
    cidadeDisabled() {
      return this.filtro.estado_id === 0;
    },
    advogadoDisabled() {
      return this.filtro.escritorio_id === 0;
    },
    tipoDisabled() {
      return this.filtro.tipoato === 0;
    }
  },
  watch: {
    datasolic(val) {
      this.filtro.datasolicitacao = this.formatDate(this.datasolic);
    },
    datasolicFim(val) {
      this.filtro.datasolicitacaoFim = this.formatDate(this.datasolicFim);
    },
    datafatal(val) {
      this.filtro.datafatal = this.formatDate(this.datafatal);
    },
    datafatalFim(val) {
      this.filtro.datafatalFim = this.formatDate(this.datafatalFim);
    },
    dataconcl(val) {
      this.filtro.dataconclusao = this.formatDate(this.dataconcl);
    },
    dataconclFim(val) {
      this.filtro.dataconclusaoFim = this.formatDate(this.dataconclFim);
    }
  },
  methods: {
    limpar() {
      this.filtro = {
        calculo_id: "",
        empresa_id: 0,
        escritorio_id: 0,
        advogado_id: 0,
        numero: "",
        estado_id: 0,
        cidade_id: 0,
        reclamante: "",
        reclamada: "",
        tipoato: 0,
        tipo_id: 0,
        solicitacao: "",
        datasolicitacao: "",
        datasolicitacaoFim: "",
        datafatal: "",
        datafatalFim: "",
        dataconclusao: "",
        dataconclusaoFim: "",
        status_id: null,
        responsavel_id: 0
      };
    },
    carregar(obj) {
      switch (obj) {
        case "advogado":
          this.$http
            .get(
              this.$urlAPI +
                "/advogado/doescritorio/" +
                this.filtro.escritorio_id,
              {
                headers: {
                  authorization: "Bearer " + this.$store.getters.getToken
                }
              }
            )
            .then(response => (this.advogados = response.data));
          break;
        case "tipo":
          this.$http
            .get(this.$urlAPI + "/tipo/portipoato/" + this.filtro.tipoato, {
              headers: {
                authorization: "Bearer " + this.$store.getters.getToken
              }
            })
            .then(response => (this.tipos = response.data));
          break;
      }
    },
    pesquisar() {
      if (this.filtro.status_id)
        if (this.filtro.status_id.length == 0) this.filtro.status_id = null;
      if (this.filtro.datasolicitacao)
        this.filtro.datasolicitacao = this.parseDate(
          this.filtro.datasolicitacao
        );
      if (this.filtro.datasolicitacaoFim)
        this.filtro.datasolicitacaoFim = this.parseDate(
          this.filtro.datasolicitacaoFim
        );
      if (this.filtro.datafatal)
        this.filtro.datafatal = this.parseDate(this.filtro.datafatal);
      if (this.filtro.datafatalFim)
        this.filtro.datafatalFim = this.parseDate(this.filtro.datafatalFim);
      if (this.filtro.dataconclusao)
        this.filtro.dataconclusao = this.parseDate(this.filtro.dataconclusao);
      if (this.filtro.dataconclusaoFim)
        this.filtro.dataconclusaoFim = this.parseDate(
          this.filtro.dataconclusaoFim
        );
      this.$http
        .post(this.$urlAPI + "/prazo/filtrar", this.filtro, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          console.log(response);

          if (response.data.status) this.items = response.data.prazos;

          if (this.filtro.datasolicitacao)
            this.filtro.datasolicitacao = this.formatDate(
              this.filtro.datasolicitacao
            );
          if (this.filtro.datasolicitacaoFim)
            this.filtro.datasolicitacaoFim = this.formatDate(
              this.filtro.datasolicitacaoFim
            );
          if (this.filtro.datafatal)
            this.filtro.datafatal = this.formatDate(this.filtro.datafatal);
          if (this.filtro.datafatalFim)
            this.filtro.datafatalFim = this.formatDate(
              this.filtro.datafatalFim
            );
          if (this.filtro.dataconclusao)
            this.filtro.dataconclusao = this.formatDate(
              this.filtro.dataconclusao
            );
          if (this.filtro.dataconclusaoFim)
            this.filtro.dataconclusaoFim = this.formatDate(
              this.filtro.dataconclusaoFim
            );

          this.$store.commit("setfiltroPrazo", this.filtro);
          sessionStorage.setItem("filtroPrazo", JSON.stringify(this.filtro));
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    getfiltros() {
      this.filtros=!this.filtros;
      this.$http
        .get(this.$urlAPI + "/empresa", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.empresas = response.data));
      this.$http
        .get(this.$urlAPI + "/escritorio", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.escritorios = response.data));
      this.$http
        .get(this.$urlAPI + "/usuario", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.usuarios = response.data));
      this.$http
        .get(this.$urlAPI + "/status", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.status = response.data));
    },
    getData: function() {
      let filAux = this.$store.getters.getfiltroPrazo;

      if (filAux) {
        this.filtro = filAux;
      }

      this.pesquisar();
    },
    openform: function(opcao, id) {
      this.$router.push("/prazo/" + id);
    }
  }
};
</script>


<style scoped>
.title-form {
  margin-bottom: -30px;
}

.v-data-table td.text-left {
  font-size: 12px;
}
</style>

